import React from 'react';
import OmCircularProgress from '../../ui/OmCircularProgress';

const StatsSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-4">
      <OmCircularProgress 
        indeterminate={true}
        size="large"
      />
      <p className="text-sm text-steel font-medium">Loading statistics...</p>
    </div>
  );
};

export default StatsSkeleton;
